import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppComponentBase} from '@shared/common/app-component-base';
import {
    ChangeCommunicationEmailDto, IChangeCommunicationEmailDto,
    ICreateVirtualBankUserInputDtoWithId, OrderScheduleServiceProxy
} from '@shared/service-proxies/service-proxies';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {finalize} from 'rxjs/operators';
import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';
import {EditCustomerMode} from '@app/webshop/shared/models';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';

@Component({
    selector: 'changeNotificationEmailModal',
    templateUrl: './change-notification-email-modal.component.html',
    styleUrls: ['./change-notification-email-modal.component.less']
})
export class ChangeNotificationEmailModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('changeNotificationEmailModal', {static: true}) modal: ModalDirective;

    @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();

    notificationEmail = '';

    isPermanent: boolean;

    active = false;
    saving = false;

    constructor(
        injector: Injector,
        private _fieldAgentOrderService: FieldAgentOrderService,
        private _orderScheduleServiceProxy: OrderScheduleServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    show(notificationEmail?: string): ModalDirective {
        this.active = true;

        if (notificationEmail) {
            this.notificationEmail = notificationEmail;
        }

        this.modal.show();
        return this.modal;
    }

    onShown(): void {
        //document.getElementById('ProjectName').focus();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    changeEmail(): void {
        this.saving = true;

        const input = {
            orderScheduleId: this._fieldAgentOrderService.orderScheduleIdValue,
            newEmail: this.notificationEmail
        } as IChangeCommunicationEmailDto;

        this._orderScheduleServiceProxy.changeCommunicationEmail(new ChangeCommunicationEmailDto(input))
            .pipe(finalize(() => this.saving = false))
            .subscribe((result) => {
                this.onSubmit.emit(this.notificationEmail);

                this.close();
            });
    }
}


